'use client'

import {Button} from "@web-libs/ui/ui-components/buttons/button";

export function PhoneCardButton ({telNumber}: { telNumber:string }) {

    return <Button text={telNumber} color={"primary"} asAnchor={true} href={`tel:${telNumber}`}></Button>
}
